import React from 'react';
import { Row, Col } from 'reactstrap';
import { Field } from "formik";
import { NeoInput } from '../../../../components/Common';

const GamificationGraduation = () => {
    return (
        <>
            <div className="mb-4 d-flex align-items-center">
                <div className="neo-section-icon-circle flex-shrink-0">
                    <i className="mdi mdi-medal-outline font-size-18 text-accent" />
                </div>
                <div className="ms-3">
                    <h5 className="mb-0 fw-bold text-dark neo-font-outfit font-size-15">Exames de Graduação</h5>
                    <p className="text-muted mb-0 font-size-12">Requisitos e recompensas por evolução de nível de faixa ou grau.</p>
                </div>
            </div>

            <Row className="g-4 mb-4">
                <Col md={4}>
                    <div className="neo-gamification-card h-100">
                        <Field name="minScoreToPassPercent">
                            {({ field, meta }) => (
                                <NeoInput
                                    {...field}
                                    type="number"
                                    label="Nota para Aprovação (%) *"
                                    placeholder="Ex: 70"
                                    error={meta.touched && meta.error ? meta.error : ''}
                                    className="mb-0"
                                />
                            )}
                        </Field>
                        <p className="text-muted font-size-11 mt-2 mb-0">Mínimo de aproveitamento exigido no exame avaliativo.</p>
                    </div>
                </Col>
                
                <Col md={4}>
                    <div className="neo-gamification-card h-100">
                        <Field name="xpRewardMemberPass">
                            {({ field, meta }) => (
                                <NeoInput
                                    {...field}
                                    type="number"
                                    label="Recompensa do Aluno (XP) *"
                                    placeholder="Ex: 100"
                                    error={meta.touched && meta.error ? meta.error : ''}
                                    className="mb-0"
                                />
                            )}
                        </Field>
                        <p className="text-muted font-size-11 mt-2 mb-0">Quantidade de XP concedida ao aluno que passar de faixa.</p>
                    </div>
                </Col>

                <Col md={4}>
                    <div className="neo-gamification-card h-100">
                        <Field name="xpRewardTeacherPass">
                            {({ field, meta }) => (
                                <NeoInput
                                    {...field}
                                    type="number"
                                    label="Recompensa do Professor (XP) *"
                                    placeholder="Ex: 50"
                                    error={meta.touched && meta.error ? meta.error : ''}
                                    className="mb-0"
                                />
                            )}
                        </Field>
                        <p className="text-muted font-size-11 mt-2 mb-0">XP que o professor orientador acumula pela graduação.</p>
                    </div>
                </Col>
            </Row>

            <div className="neo-switch-premium-panel mb-2 d-flex flex-column">
                <div className="d-flex align-items-center mb-2">
                    <div className="form-check form-switch form-switch-md d-flex align-items-center mb-0 p-0">
                        <Field 
                            type="checkbox" 
                            name="requireFundamentalsMaxScore" 
                            id="requireFundamentalsMaxScore" 
                            className="form-check-input mt-0 me-3 cursor-pointer ms-0"
                        />
                        <label 
                            className="form-check-label mb-0 fw-bold text-dark font-size-14 cursor-pointer neo-font-outfit" 
                            htmlFor="requireFundamentalsMaxScore"
                        >
                            Exigir Nota Máxima em Tópicos Fundamentais
                        </label>
                    </div>
                </div>
                <p className="text-muted mb-0 font-size-12 ps-md-5">
                    Marque essa opção se deseja que o aluno passe de nível somente quando todos os tópicos marcados como fundamentais na malha pedagógica estiverem com nota máxima.
                </p>
            </div>
        </>
    );
};

export default GamificationGraduation;
